<template>
		<v-dialog persistent v-model="dialog" width="400">
      <v-card class="pa-20 textAlignCenter">
        <h3>"{{item.employee_name}}"?</h3>
        <h4>Usuario sin correo.</h4>
        <br>
        <div>
          <v-text-field placeholder="email del usuario"
            clearable
            prepend-icon="edit" 
            :class="!item.email && 'textEmpty'"
            v-model="item.email"/>
        </div>
        <br>
        <br>
        <div>
          <v-btn color="secondary" @click="$emit('update:dialog', false)">
            <v-icon>reply</v-icon>
            <span>Cancelar</span>
          </v-btn>
          <v-btn color="primary"  @click="editItem">
            <v-icon>save</v-icon>
            <span>Aceptar</span>
          </v-btn>
        </div>
      </v-card>
		</v-dialog>
</template>

<script>
import { editUser } from '@/requests/ac';

export default {
  props: {
    item:{
      default: () => {return {}}
    },
    dialog:{
      default: false
    }
  },
  computed: {
    edit() {return editUser }
  },
  methods: {
  async editItem() {
    this.$emit('update:dialog', false);
    this.setProgress({message: 'Guardando...', show:true});
    if(!await this.assignAccess()) return this.getError('no se pudo obtener acceso');
  
    this.edit(this.item)
      .then(r => {
        this.setProgress({show:false});
        r.id
          ? this.setSnackbar({message:'Guardado.',class:'success'})
          : this.setSnackbar({message:'Ocurrió un problema.',class:'error'});
      })
      .catch(e => this.getError(e))
    }
  }, // methods
};
</script>
